// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfv_a bhs_vc bhs_rm bhs_wf"};